import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { datadogRum } from '@datadog/browser-rum';
import { getDatadogViewName } from './datadogRum';

/**
 * Component that tracks route changes in Datadog RUM with region information.
 *
 * This component listens to React Router location changes and automatically
 * creates Datadog RUM views with the format: `{region}/{routeName}`
 */
export const DatadogRouteTracker = () => {
  const location = useLocation();
  const isInitialMount = useRef(true);

  useEffect(() => {
    // Skip the initial mount since the view was already set in datadogRum.ts. We want to do it on
    // initial load rather than route load for accurate timing information.
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (typeof datadogRum === 'undefined') {
      return;
    }

    const viewName = getDatadogViewName(location.pathname);
    if (viewName) {
      datadogRum.startView({ name: viewName });
    }
  }, [location.pathname]);

  return null;
};
